module.exports = __webpack_public_path__ + "img/triangle.4bd80289.svg";